(() => {
  const STORAGE_KEY = 'topferoRecentlyViewedProducts:v2';
  const MAX_STORED_PRODUCTS = 12;
  const MIN_VISIBLE_PRODUCTS = 4;

  const readStoredProducts = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((product) => product && product.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const writeStoredProducts = (products) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products.slice(0, MAX_STORED_PRODUCTS)));
    } catch (error) {
      // Browsers can block storage in private modes. The section can simply stay hidden.
    }
  };

  const renderCard = (product) => {
    if (!product.cardHtml) return '';

    return `
      <div class="tf-product-slider__item" role="listitem">
        ${product.cardHtml}
      </div>
    `;
  };

  const hideSection = (section, track) => {
    if (track) track.innerHTML = '';
    section.hidden = true;
    section.setAttribute('aria-hidden', 'true');
    section.dataset.tfRecentlyViewedState = 'hidden';
    section.style.display = 'none';
    section.style.visibility = '';
  };

  const revealSection = (section) => {
    section.hidden = false;
    section.setAttribute('aria-hidden', 'false');
    section.dataset.tfRecentlyViewedState = 'visible';
    section.style.display = '';
    section.style.visibility = '';
  };

  const initRecentlyViewed = (section) => {
    if (!section || section.dataset.tfRecentlyViewedReady === 'true') return;

    const currentScript = section.querySelector('[data-tf-recently-viewed-current]');
    const track = section.querySelector('[data-tf-product-slider-track]');
    if (!currentScript || !track) return;

    section.dataset.tfRecentlyViewedReady = 'true';
    section.hidden = false;
    section.style.display = '';
    section.style.visibility = '';
    section.setAttribute('aria-hidden', 'true');
    section.dataset.tfRecentlyViewedState = 'loading';

    let currentProduct;
    try {
      currentProduct = JSON.parse(currentScript.textContent || '{}');
    } catch (error) {
      currentProduct = null;
    }

    if (!currentProduct?.handle) {
      hideSection(section, track);
      writeStoredProducts(readStoredProducts());
      return;
    }

    const storedProducts = readStoredProducts();
    const previousProducts = storedProducts.filter((storedProduct) => {
      return (
        storedProduct.handle !== currentProduct.handle &&
        typeof storedProduct.cardHtml === 'string' &&
        storedProduct.cardHtml.trim() !== ''
      );
    });
    const configuredLimit = Number(section.dataset.limit || 6);
    const limit = Math.max(MIN_VISIBLE_PRODUCTS, configuredLimit);
    const visibleProducts = previousProducts.slice(0, limit);

    if (visibleProducts.length >= MIN_VISIBLE_PRODUCTS) {
      track.innerHTML = visibleProducts.map(renderCard).join('');
      const slider = section.querySelector('[data-tf-product-slider]');
      if (slider) slider.classList.remove('tf-product-slider--loading');

      const renderedItems = Array.from(track.children).filter((item) => {
        return item.matches('.tf-product-slider__item') && item.querySelector('a[href], .card-wrapper');
      });
      section.style.visibility = 'hidden';
      section.style.display = '';
      section.hidden = false;
      section.setAttribute('aria-hidden', 'true');
      section.dataset.tfRecentlyViewedState = 'measuring';
      const hasRenderableTrack = track.scrollHeight > 0 && renderedItems.every((item) => item.textContent.trim() !== '');

      if (renderedItems.length >= MIN_VISIBLE_PRODUCTS && hasRenderableTrack) {
        revealSection(section);
        window.dispatchEvent(new Event('resize'));
      } else {
        hideSection(section, track);
      }
    } else {
      hideSection(section, track);
    }

    writeStoredProducts([currentProduct, ...previousProducts]);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-tf-recently-viewed]').forEach(initRecentlyViewed);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
